export class ListTestResourceSnapshots200ResponseSnapshotsInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListTestResourceSnapshots200ResponseSnapshotsInner.attributeTypeMap;
    }
    constructor() {
    }
}
